<template>
  <ValidationProvider :vid="vid" :name="$attrs.label" :rules="rules">
    <el-form-item
      slot-scope="{ errors }"
      :error="errors[0]"
      :label="$attrs.label"
      class="w-full"
    >
      <el-select :placeholder="placeholder" class="w-full" v-model="innerValue" v-bind="$attrs">
        <slot />
      </el-select>
    </el-form-item>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },
  props: {
    placeholder:{
      type:String
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
<style scoped>
.w-full{
  width: 100%;
}
</style>
